var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconErrorFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FF5670",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17478 16.3816C6.51613 17.3974 8.18769 18 10 18C14.4183 18 18 14.4183 18 10C18 8.18769 17.3974 6.51613 16.3816 5.17478L5.17478 16.3816ZM3.74276 14.9852C2.65199 13.6179 2 11.8851 2 10C2 5.58172 5.58172 2 10 2C11.8851 2 13.6179 2.65199 14.9852 3.74276L3.74276 14.9852Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorFill);
export default __webpack_public_path__ + "static/media/icon-error-fill.58b2137a0c6c4c274414d7ec8c3363c5.svg";
export { ForwardRef as ReactComponent };